import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as Layers from '@bubble-ui/particle-layers';
import { getBackgroundColor, getBorderColor, getLabelTextColor } from '@bubble-ui/temp-form-element-colors';
export var getDefaultStyleSheet = _ref => {
  var {
    autofill,
    designContext,
    designVersion,
    disabled,
    error,
    fieldTooltip,
    focused,
    hovered,
    label,
    loading,
    tooltipActive,
    UNSAFE_width,
    warning,
    width
  } = _ref;
  return {
    rootStyle: {
      flex: UNSAFE_width,
      width
    },
    arrowStyle: {
      alignSelf: 'center',
      paddingLeft: 5,
      position: 'relative',
      top: focused ? 1 : 0
    },
    containerStyle: {
      backgroundColor: getBackgroundColor({
        autofill,
        designVersion,
        disabled,
        error,
        focused,
        hovered,
        warning
      }),
      borderBottomColor: getBorderColor({
        autofill,
        designVersion,
        disabled,
        error,
        hovered,
        focused,
        loading,
        warning
      }),
      borderBottomStyle: 'solid',
      borderBottomWidth: disabled ? 1 : focused ? 2 : 1,
      borderBottomRadius: 2,
      boxSizing: 'border-box',
      flexDirection: 'row',
      flexGrow: 1,
      flexShrink: 1,
      height: 60,
      justifyContent: 'space-between',
      position: 'relative',
      zIndex: tooltipActive ? Layers.TOOLTIP : hovered ? Layers.HOVER : focused ? Layers.FOCUS : Layers.BASE
    },
    backgroundStyle: {
      height: focused ? 58 : 59,
      position: 'absolute',
      width: '100%'
    },
    textWrapperStyle: {
      flexDirection: 'column',
      flexGrow: 0,
      flexShrink: 1,
      position: 'relative',
      width: '100%'
    },
    labelTextStyle: fontSize => _objectSpread(_objectSpread({
      color: getLabelTextColor({
        designVersion,
        disabled,
        error,
        warning
      }).toString()
    }, designContext.get('text-style/text/paragraphs/body/regular').styles()), {}, {
      fontSize,
      lineHeight: 30,
      overflow: 'hidden',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    }),
    labelViewStyle: marginTop => ({
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      position: 'relative',
      pointerEvents: 'none',
      paddingLeft: error || warning ? 25 : 0,
      paddingRight: fieldTooltip ? 30 : 0,
      marginTop,
      width: '100%'
    }),
    labelFeedbackStateIconStyle: {
      width: 20,
      height: 20,
      position: 'absolute',
      top: 4,
      left: 0
    },
    selectedOptionStyle: _objectSpread(_objectSpread({
      color: designContext.get('colors/text/default', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('text-style/text/paragraphs/body/medium').styles()), {}, {
      lineHeight: undefined,
      height: '60px',
      opacity: disabled ? 0.5 : 1,
      overflow: 'hidden',
      position: 'absolute',
      textRendering: 'geometricPrecision',
      textOverflow: 'ellipsis',
      top: 0,
      marginTop: label ? 30 : 20,
      WebkitFontSmoothing: 'antialiased',
      whiteSpace: 'nowrap',
      width: '100%'
    }),
    selectStyle: {
      cursor: disabled ? 'auto' : 'pointer',
      fontSize: 16,
      height: '60px',
      left: 0,
      opacity: 0,
      position: 'absolute',
      top: 0,
      WebkitAppearance: 'menulist-button',
      width: '100%',
      zIndex: disabled ? -1 : 2
    },
    loaderStyle: {
      alignSelf: 'center',
      paddingLeft: 5
    },
    iconStyle: {
      colorToken: focused || error || warning || autofill ? 'colors/text/default' : 'colors/text/neutral',
      colorTokenArgs: {
        interactiveState: disabled ? 'disabled' : 'default'
      }
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map